import CookiesJS from 'cookies-js';

export function initInitialPractices($, apiClient) {
    $('form.initial-practices-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const practices = [];
            $('#practices .array-item').each(function () {
                practices.push({
                    practiceId: $(this).find('select.practices-practiceId').val(),
                    time: $(this).find('.practices-time').val(),
                    weekDays: $(this).find('select.practices-weekDays').val(),
                });
            });
            const body = {
                practices,
                deleted: !!$('#deleted').prop('checked'),
            };

            if (!_id) {
                const result = await apiClient.create('/initial-practices', body, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/initial-practices/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/initial-practices', _id, body, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
